import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import logo from '../../assets/images/IE_logo.png';
import bglogo from '../../assets/images/IE_logo_favicon.png';
import signature from '../../assets/images/principale_officer_signature.png';
import bage from '../../assets/images/bage-removebg.png';
import { getSessionToken } from 'utils/session';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { dotPulse } from 'ldrs';
dotPulse.register();

const Certificate = () => {
  const [candidateData, setCandidateData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const getCandidateData = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/pos/pos_certificate/`, {
        headers: {
          Authorization: `Bearer ${getSessionToken()}`,
        },
      })
      .then((res) => {
        setCandidateData(res.data);
      })
      .catch((err) => {
        console.err(err, 'error');
        if (err.response.status === 500 || err.response.status === 400) {
          navigate(`/posp/error404`);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (getSessionToken()) {
      getCandidateData();
    } else {
      navigate(`/posp/error404`);
    }
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };

  const certificateRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => certificateRef.current,
  });

  return loading ? (
    <div className="flex justify-center items-center h-screen bg-white">
      <div className="flex items-center space-x-2 text-gray-700 text-lg ">
        <span className="text-3xl text-bold text-slate-600">Loading</span>
        <l-dot-pulse size="35" speed="1.3" color="gray"></l-dot-pulse>
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 overflow-x-auto">
      <div
        ref={certificateRef}
        className="relative bg-white p-2 shadow-2xl border-8 border-blue-900   w-[1064px] text-center overflow-hidden"
      >
        <div className="relative bg-white p-10 border-2 border-blue-900  w-[1032px] text-center">
          {/* Watermark */}
          <img
            src={bglogo}
            alt="Watermark"
            className="absolute opacity-10 w-64 top-1/4 left-1/2 transform -translate-x-1/2"
          />

          {/* Header */}
          <div className="flex justify-between items-center mb-6">
            <img src={logo} alt="Company Logo" className="h-10" />
            <h1 className="text-5xl font-bold text-blue-900 font-[Niconne] ">
              Certificate of Point of Sale Person
            </h1>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>

          {/* Certificate Body */}
          <p className="text-lg text-gray-800 mb-8 mt-8 ">This is to certify</p>
          <p className="text-5xl underline font-bold text-blue-900 mb-8 font-[Niconne]">
            {candidateData.name}
          </p>

          <p className="text-lg text-gray-800 mb-4">
            Bearing PAN Number{' '}
            <span className="font-bold">{candidateData.pan_no}</span> has
            successfully completed training and qualified the examination
            specified for Point of Sale Person conducted under the guidelines of
            IRDAI, and will be an authorized PoSP of
            <span className="font-bold">
              {' '}
              Efficient Insurance Brokers Pvt Limited
            </span>
            .
          </p>

          {/* Footer */}
          <div className="mt-20 flex justify-between items-center text-gray-800 text-sm flex-wrap">
            <div className="text-left pl-4 pt-28">
              <p>
                Certificate No:{' '}
                <span className="font-bold">
                  {candidateData.certificate_no}
                </span>
              </p>
              <p>
                Issued On:{' '}
                <span className="font-bold">
                  {formatDate(candidateData.issued_date)}
                </span>
              </p>
            </div>

            <div>
              <img src={bage} alt="certified" className="h-20 mt-20" />
            </div>
            <div className="text-right">
              <p>Authorized Signatory</p>
              <img src={signature} alt="signature" className="h-20 ml-28" />
              <p className="text-md font-bold">Mr. Prasad Shinde</p>
              <p className="text-md ">Principal Officer</p>

              <p className="text-sm text-gray-500 font-bold">
                EFFICIENT Insurance Brokers Pvt. Ltd.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Download Button */}
      <button
        onClick={handlePrint}
        className="mt-6 bg-yellow-500 text-white px-6 py-2 rounded-lg shadow-lg hover:bg-yellow-600 transition"
      >
        Download Certificate
      </button>
    </div>
  );
};

export default Certificate;
